import * as angular from 'angular';

import { ComponentDefinition, lineStyles } from '../../models';

class LineStyleSelectionController implements angular.IComponentController {
    isLineVisible: boolean;
    items: string[];
    model: string;
    series: any;
    type: string;

    static $inject = [];

    $onInit() {
        if (!this.model) {
            this.model = lineStyles[0];
        }
    }
    
    setLineStyle(lineStyle: string): void {
        this.model = lineStyle;
    }
}

export const wtLineStyleSelection: ComponentDefinition = {
    componentId: 'wtLineStyleSelection',
    controller: LineStyleSelectionController,
    template: require('./lineStyleSelection.component.html'),
    controllerAs: 'vm',
    bindings: {
        items: '<',
        model: '=',
        isLineVisible: '<',
        type: '<',
        series: '<'
    }
};